export default __webpack_public_path__ + "static/media/KanandaFerreira_05.8e46f63f.jpg";